// src/context/Adviser/Utils/FinancialPromotionAdviserHelpers.js

import { subscribeAdviserFullDetailsByEmailOrId } from "./AdviserLiveDetails";

export const normaliseExternalUrl = (value) => {
  const trimmed = String(value || "").trim();

  if (!trimmed) return "";

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  return `https://${trimmed}`;
};

export const getLiveAdviserName = (data = {}, fallback = "") => {
  const personalDetails = data.personalDetails || {};
  const adviserDoc = data.adviserDoc || {};

  const fullName = [personalDetails.forename, personalDetails.surname]
    .filter(Boolean)
    .join(" ")
    .trim();

  return (
    fullName ||
    adviserDoc.name ||
    adviserDoc.adviserName ||
    adviserDoc.displayName ||
    fallback
  );
};

export const getLiveAdviserTradingName = (data = {}, fallback = "") => {
  const adviserDoc = data.adviserDoc || {};

  return (
    adviserDoc.tradingName ||
    adviserDoc.tradingStyle ||
    adviserDoc.companyName ||
    fallback
  );
};

export const getLiveAdviserSocialLinks = (data = {}) => {
  const adviserDoc = data.adviserDoc || {};

  return {
    website: adviserDoc.website || "",
    linkedin: adviserDoc.linkedin || adviserDoc.linkedIn || "",
    facebook: adviserDoc.facebook || "",
    instagram: adviserDoc.instagram || "",
    tiktok: adviserDoc.tiktok || adviserDoc.tikTok || "",
  };
};

export const buildFinancialPromotionAdviserProfile = (
  email,
  data = {},
  fallback = {},
) => {
  return {
    email,
    adviserName: getLiveAdviserName(data, fallback.adviserName || email),
    tradingName: getLiveAdviserTradingName(data, fallback.tradingName || email),
    ...getLiveAdviserSocialLinks(data),
  };
};

export const subscribeFinancialPromotionAdviserProfiles = ({
  adviserEmails = [],
  onData,
  onError,
}) => {
  const uniqueEmails = [...new Set(adviserEmails.filter(Boolean))];

  if (!uniqueEmails.length) {
    onData?.({});
    return () => {};
  }

  const profilesByEmail = {};
  const unsubscribers = uniqueEmails.map((email) =>
    subscribeAdviserFullDetailsByEmailOrId(
      email,
      (data) => {
        profilesByEmail[email] = buildFinancialPromotionAdviserProfile(
          email,
          data,
          profilesByEmail[email] || {},
        );

        onData?.({ ...profilesByEmail });
      },
      onError,
    ),
  );

  return () => {
    unsubscribers.forEach((unsubscribe) => unsubscribe?.());
  };
};
